import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import GoogleButton from "@/components/GoogleButton";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", birth_date: "", password: "" });
  const [terms, setTerms] = useState(false);
  const [privacy, setPrivacy] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register({ ...f, language: "it", country: "IT", accept_terms: terms, accept_privacy: privacy });
      navigate("/onboarding");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Registrati" subtitle="In un minuto. Riservato ai maggiorenni.">
      <GoogleButton label="Registrati con Google" />
      <p className="text-xs text-center text-[#4A4E68] mt-2">Continuando accetti i <Link to="/terms" className="text-[#141A3A] underline">Termini</Link> e la <Link to="/privacy" className="text-[#141A3A] underline">Privacy</Link>.</p>
      <div className="flex items-center gap-3 my-4">
        <div className="h-px flex-1 bg-[#DADFEA]" />
        <span className="text-xs text-[#4A4E68]">oppure con email</span>
        <div className="h-px flex-1 bg-[#DADFEA]" />
      </div>
      <form onSubmit={submit} className="space-y-3" data-testid="register-form">
        <div><Label>Nome</Label><Input data-testid="reg-name" value={f.name} onChange={set("name")} required className="mt-1" /></div>
        <div><Label>Email</Label><Input data-testid="reg-email" type="email" value={f.email} onChange={set("email")} required className="mt-1" /></div>
        <div><Label>Cellulare (formato internazionale)</Label><Input data-testid="reg-phone" placeholder="+39..." value={f.phone} onChange={set("phone")} required className="mt-1" /></div>
        <div><Label>Data di nascita</Label><Input data-testid="reg-birth" type="date" value={f.birth_date} onChange={set("birth_date")} required className="mt-1" /></div>
        <div><Label>Password</Label><Input data-testid="reg-password" type="password" value={f.password} onChange={set("password")} required minLength={6} className="mt-1" /></div>
        <label className="flex items-start gap-2 text-sm text-[#4A4E68]">
          <Checkbox data-testid="reg-terms" checked={terms} onCheckedChange={setTerms} className="mt-0.5" />
          Accetto i <Link to="/terms" className="text-[#141A3A] underline">Termini d'uso</Link>
        </label>
        <label className="flex items-start gap-2 text-sm text-[#4A4E68]">
          <Checkbox data-testid="reg-privacy" checked={privacy} onCheckedChange={setPrivacy} className="mt-0.5" />
          Ho letto la <Link to="/privacy" className="text-[#141A3A] underline">Privacy</Link>
        </label>
        {error && <p data-testid="register-error" className="text-sm text-[#C0392B]">{error}</p>}
        <Button type="submit" data-testid="register-submit" disabled={loading} className="w-full h-12 bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230] text-base rounded-full">
          {loading ? "Creazione..." : "Crea account"}
        </Button>
        <p className="text-center text-sm text-[#4A4E68]">Hai già un account? <Link to="/login" className="text-[#141A3A] font-medium">Accedi</Link></p>
      </form>
    </AuthShell>
  );
}
